import { useState } from 'react';

import { useAppSelector } from 'hooks';

import { Box, Text, Icon } from '@chakra-ui/react';

import { QuestionIcon } from '@chakra-ui/icons';

import { HamburgerIcon } from '@chakra-ui/icons';

// @ts-ignore
import { HashLink } from 'react-router-hash-link';

import { SharedSectionMenuProps } from './SectionMenu.types';

const SharedSectionMenu = ({
  sections,
  formStateKey,
}: SharedSectionMenuProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const missingFields = useAppSelector(
    (state) => state[formStateKey].missingMandatoryFields,
  );

  const missingRemarks = useAppSelector((state) =>
    state[formStateKey].remarks.filter(
      (r) =>
        r.status !== 'approved' &&
        !(r.validation_key === '133b' && r.status === 'failed'),
    ),
  );

  const missingFiles = useAppSelector((state) =>
    state[formStateKey].files.filter((f) => f.status !== 'approved'),
  );

  const scrollWithOffset = (el: any) => {
    setIsOpen(false);
    const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
    const yOffset = -164;
    window.scrollTo({ top: yCoordinate + yOffset, behavior: 'smooth' });
  };

  const hasMissingData = (section: number) => {
    if (!section) return false;

    // Look for section ID in missing fields
    if (missingFields.some((field) => field.section === section)) {
      return true;
    }

    // Look for section ID in missing remarks
    if (
      Object.values(missingRemarks).some((item) => item.section === section)
    ) {
      return true;
    }

    // Look for section ID in missing uploads
    if (missingFiles.some((item) => item.section === section)) {
      return true;
    }

    return false;
  };

  return (
    <Box
      position="fixed"
      w={{
        base: 'calc(100% - 40px)',
        xl: 'calc(100% - 340px)',
      }}
      zIndex={1}
      cursor="pointer"
      onClick={() => setIsOpen(!isOpen)}
      top="105px"
    >
      <Box
        backgroundColor="brand.400"
        color="white"
        p="10px"
        pl="20px"
        pr="20px"
        borderBottomRadius="10px"
      >
        <Text fontWeight="bold" fontSize="l">
          Navigation
          <Box float="right">
            <HamburgerIcon />
          </Box>
        </Text>
        {isOpen && (
          <Box mt="10px">
            {sections.map((section, index) => (
              <Box key={index}>
                <HashLink
                  smooth
                  to={`#${section.link}`}
                  scroll={scrollWithOffset}
                >
                  <Text
                    textDecoration={'none'}
                    _hover={{ textDecoration: 'underline' }}
                  >
                    {section.name}
                    {hasMissingData(section.section) && (
                      <Icon
                        w="20px"
                        h="20px"
                        ml="10px"
                        color="orange.500"
                        as={QuestionIcon}
                      />
                    )}
                  </Text>
                </HashLink>
              </Box>
            ))}
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default SharedSectionMenu;
